import { CaretSortIcon } from '@radix-ui/react-icons';
import { Search } from 'lucide-react';
import { ChangeEvent, useEffect, useMemo, useRef, useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger, Skeleton } from '../../ui';
import { MainContextProvider, useMainContext } from './MainContext';
import RenderSelectedValues from './RenderSelectedValues';
import VirtualListFormMultiSelect from './VirtualListFormMultiSelect';

import { ClassValue } from 'clsx';
import { cn, optionTypes } from 'src/helpers';


type Props = {
    options: optionTypes[],
    onchange?: (e: any) => void
    searchable?: boolean,
    disabled?: boolean,
    isLoading?: boolean,
    labelStyle?: string,
    className?: ClassValue
    value?: any
    required?: boolean
    placeholder?: string,
    dropDwnBtnWidth?:string
}

const Main = ({ options, onchange, searchable, disabled, isLoading, className, value, required, placeholder,dropDwnBtnWidth }: Props) => {

    const { selectedValues, toggleValue } = useMainContext()
    const popupref = useRef<any>(null);
    const [width, setwidth] = useState(0)
    const [searchText, setsearchText] = useState<string>("")

    useEffect(() => {
        setwidth(popupref?.current?.clientWidth)
        return () => { }
    }, [popupref])

    useEffect(() => {
        if (value && options) {
            toggleValue(options.find((d: optionTypes) => d.value.toLowerCase() === (value.toLowerCase())))
        }
        else toggleValue(undefined)
        return () => { }
    }, [value, options,toggleValue])


    let data = useMemo(() => {
        if (searchText !== "") {
            return options.filter((d: optionTypes) => d.value.toLowerCase().includes(searchText.toLowerCase()))
        }
        else return options
    }, [options, searchText])

    return (
        <div className={`min-w-[${dropDwnBtnWidth}px]`}>
            <Popover>
                <PopoverTrigger asChild>
                    <div
                        key={'multi-picker-trigger'}
                        ref={popupref}
                        role="combobox"
                        className={cn(
                            " bg-white flex w-full text-sm justify-between items-center px-2 font-normal min-h-[40px] border rounded ", className, {
                            // "pointer-events-none bg-gray-100": disabled
                        })}
                    >

                        {isLoading ? <Skeleton className="w-full h-[15px]" /> : <div className="">
                            {selectedValues && selectedValues ? <RenderSelectedValues /> : `${placeholder ? placeholder : "select"} `}
                        </div>}

                        <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                    </div>
                </PopoverTrigger>
                {width && <PopoverContent className={cn("p-0 ")} style={{ minWidth: '150px' }} align="start">
                    <div className={cn(`relative p-1 z-50 overflow-hidden rounded-md border bg-popover text-popover-foreground  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2`, { width: width })}  >
                        <div className='flex flex-col'>
                            {searchable && <div className='flex items-center space-x-1 m-2'>
                                <Search className="mr-2 h-4 w-4 shrink-0 opacity-50" />
                                <input
                                    type="text"
                                    className="focus:outline-none hover:outline-none py-2 text-sm w-full  "
                                    placeholder="Search"
                                    value={searchText}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                        setsearchText(e.target.value.toLowerCase())
                                    }
                                />
                            </div>}
                            <VirtualListFormMultiSelect
                                data={data}
                                onchange={(e: any) => {
                                    onchange && onchange(e?.value || "")
                                    popupref.current?.click();
                                }}
                                selectedValues={selectedValues}
                            />
                        </div>
                    </div>
                </PopoverContent>}
            </Popover>
        </div>
    )
}

const SelectPicker2 = ({ labelStyle, ...rest }: Props) => {

    return <div>
        <MainContextProvider>
            <Main {...rest} />
        </MainContextProvider>
    </div>

}

export default SelectPicker2